import React from 'react';
import moment from 'moment';
import { useTeamColors } from 'hooks';

import {
  TemperatureIcon,
  RainIcon,
  SnowIcon,
  HumidityIcon,
  SunIcon,
  WindIcon,
  CloudIcon,
} from 'assets/icons';

import {
  WeatherContainer,
  WeatherIcon,
  WeatherInfoSection,
  WeatherInfoIconSection,
  ErrorContainer,
  WeatherHeader,
  WeatherHeaderTitle,
  WeatherHeaderDate,
} from '../style';

export const WeatherGameInfo = ({ city, data, date, stadium }) => {
  const { altColor } = useTeamColors();
  const localTimezone = data?.location?.tz_id;
  const forecastDays = data?.forecast?.forecastday;

  if (!forecastDays || !Array.isArray(forecastDays)) {
    return (
      <ErrorContainer $mainColor={altColor}>
        Weather forecast data is currently unavailable.
      </ErrorContainer>
    );
  }

  const foundDayWeather = forecastDays.find(
    (forecastDay) =>
      forecastDay.date ===
      moment.utc(date).tz(localTimezone).format('YYYY-MM-DD')
  );

  const isImperialMetric = data?.location.tz_id.includes('America');

  if (!foundDayWeather?.day) {
    return (
      <ErrorContainer $mainColor={altColor}>
        Weather forecast for game day is currently unavailable.
      </ErrorContainer>
    );
  }

  const gameDayWeather = foundDayWeather?.day;

  // Format date
  const formattedDate = moment
    .utc(date)
    .tz(localTimezone)
    .format('dddd, MMMM D, YYYY');

  return (
    <WeatherContainer>
      {stadium || city ? (
        <WeatherHeader>
          <WeatherHeaderTitle>
            {stadium && city ? `${stadium} in ${city}` : stadium || city}
          </WeatherHeaderTitle>
          <WeatherHeaderDate>{formattedDate}</WeatherHeaderDate>
        </WeatherHeader>
      ) : null}
      <WeatherInfoSection>
        <WeatherInfoIconSection>
          <WeatherIcon $iconColor={altColor}>
            <TemperatureIcon />
          </WeatherIcon>
          High / Low
        </WeatherInfoIconSection>
        <span>
          {isImperialMetric
            ? `${gameDayWeather.maxtemp_f}F`
            : `${gameDayWeather.maxtemp_с}C`}
          {' / '}
          {isImperialMetric
            ? `${gameDayWeather.mintemp_f}F`
            : `${gameDayWeather.mintemp_с}C`}
        </span>
      </WeatherInfoSection>
      <WeatherInfoSection>
        <WeatherInfoIconSection>
          <WeatherIcon $iconColor={altColor}>
            <RainIcon />
          </WeatherIcon>
          Chance of rain:
        </WeatherInfoIconSection>
        <span>{gameDayWeather.daily_chance_of_rain}%</span>
      </WeatherInfoSection>
      <WeatherInfoSection>
        <WeatherInfoIconSection>
          <WeatherIcon $iconColor={altColor}>
            <SnowIcon />
          </WeatherIcon>
          Chance of snow:
        </WeatherInfoIconSection>
        <span>{gameDayWeather.daily_chance_of_snow}%</span>
      </WeatherInfoSection>
      <WeatherInfoSection>
        <WeatherInfoIconSection>
          <WeatherIcon $iconColor={altColor}>
            <HumidityIcon />
          </WeatherIcon>
          Humidity:
        </WeatherInfoIconSection>
        <span>{gameDayWeather.avghumidity}%</span>
      </WeatherInfoSection>
      <WeatherInfoSection>
        <WeatherInfoIconSection>
          <WeatherIcon $iconColor={altColor}>
            <WindIcon />
          </WeatherIcon>
          Wind:
        </WeatherInfoIconSection>
        <span>
          {isImperialMetric
            ? `${gameDayWeather.maxwind_mph}m/h`
            : `${gameDayWeather.maxwind_kph}km/h`}
        </span>
      </WeatherInfoSection>
      <WeatherInfoSection>
        <WeatherInfoIconSection>
          <WeatherIcon $iconColor={altColor}>
            <SunIcon />
          </WeatherIcon>
          UV Index:
        </WeatherInfoIconSection>
        <span>{gameDayWeather.uv}</span>
      </WeatherInfoSection>
      <WeatherInfoSection>
        <WeatherInfoIconSection>
          <WeatherIcon $iconColor={altColor}>
            <CloudIcon />
          </WeatherIcon>
          Condition:
        </WeatherInfoIconSection>
        <span>{gameDayWeather.condition.text}</span>
      </WeatherInfoSection>
    </WeatherContainer>
  );
};
